import apiClient from "./apiClient";

const dashboardApi = {
  getGeneralStats: async () => {
    const res = await apiClient.get("/analytics/dashboard/general-stats");
    return res.data;
  },
  getHraMetabolicRisk: async () => {
    const res = await apiClient.get("/analytics/dashboard/hra/metabolic-risk");
    return res.data;
  },
  getHraImc: async () => {
    const res = await apiClient.get("/analytics/dashboard/hra/imc");
    return res.data;
  },
  getHraTopDiseases: async () => {
    const res = await apiClient.get("/analytics/dashboard/hra/top-diseases");
    return res.data;
  },
  getInbodyBmi: async () => {
    const res = await apiClient.get("/analytics/dashboard/inbody/bmi");
    return res.data;
  },
  getInbodyPbf: async () => {
    const res = await apiClient.get("/analytics/dashboard/inbody/pbf");
    return res.data;
  },
  getInbodyVfl: async () => {
    const res = await apiClient.get("/analytics/dashboard/inbody/vfl");
    return res.data;
  },
  getLabAnalytics: async () => {
    const res = await apiClient.get("/analytics/dashboard/lab");
    return res.data;
  },
  getTygAnalytics: async () => {
    const res = await apiClient.get("/analytics/dashboard/lab/tyg");
    return res.data;
  },
  getMetabolicRiskReal: async (companyId, crossFilter) => {
    const params = {};
    if (companyId) params.companyId = companyId;
    if (crossFilter) {
      params.ibMonth  = crossFilter.ibPeriod.month;  params.ibYear  = crossFilter.ibPeriod.year;
      params.labMonth = crossFilter.labPeriod.month; params.labYear = crossFilter.labPeriod.year;
    }
    const res = await apiClient.get("/analytics/dashboard/metabolic-risk/real", { params });
    return res.data;
  },
  getCompaniesWithCrosses: async () => {
    const res = await apiClient.get("/analytics/dashboard/metabolic-risk/companies-with-crosses");
    return res.data; // [{ _id, name }]
  },
  getAvailableCrossesForCompany: async (companyId) => {
    const res = await apiClient.get("/analytics/dashboard/metabolic-risk/real/crosses", { params: { companyId } });
    return res.data;
  },
};

export default dashboardApi;
